// extracted by mini-css-extract-plugin
export var addButton = "_gv-0";
export var border = "_gv-8";
export var check = "_gv-h";
export var danger = "_gv-6";
export var dropdownContainer = "_gv-1";
export var editModalBody = "_gv-j";
export var footerContainer = "_gv-i";
export var fullWidth = "_gv-a";
export var hide = "_gv-9";
export var icon = "_gv-3";
export var input = "_gv-7";
export var inputFlex = "_gv-b";
export var inputWrapper = "_gv-c";
export var manualFocus = "_gv-5";
export var optionButton = "_gv-4";
export var pillWrapper = "_gv-e";
export var pointer = "_gv-2";
export var showOverflow = "_gv-f";
export var tagsFlex = "_gv-d";
export var xButton = "_gv-g";